<!--
 * @title:
 * @fileName: PageEditLayout
 * @projectName WEB
 * @author ：yaaynn
 * @date ：2020/5/28 11:47
 * @modified By：
 * @version:     1.0$
 * @description: TODO
-->
<template>
    <div class="common-body">
        <div class="page-edit-layout-container">
            <slot name="button"></slot>
            <slot></slot>
        </div>
        <div class="page-edit-layout-footer">
            <billing-info :billingInfo="value"></billing-info>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PageEditLayout",
        props: {
            value: {
                type: Object
            },
        },
    }
</script>

<style scoped lang="scss">
.page-edit-layout-container {
    overflow-y:auto;
    overflow-x:hidden;
    position: absolute;
    top:0;
    left: 0;
    right: 0;
    bottom: 60px;
    .header {
        height: 60px;
        width: 100%;
        border-bottom: 1px solid #F6F6F6;
    }
    .main-container{
        position: absolute;
        top: 60px;
        left: 0;
        right: 0;
        bottom: 0;
        overflow-y: auto;
    }
}
.page-edit-layout-footer{
    position: absolute;
    top: auto;
    left: 0;
    right: 0;
    bottom: 0;
    height: 60px;
    box-sizing: border-box;
    padding: 20px;
    border-top: 1px solid #CFD7E5;
    margin: 0 -20px;
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/Pages/layout/PageEditLayout.vue"
}
</vue-filename-injector>
